import { render, staticRenderFns } from "./FormAlunoBasic.vue?vue&type=template&id=17623592&scoped=true"
import script from "./FormAlunoBasic.vue?vue&type=script&lang=js"
export * from "./FormAlunoBasic.vue?vue&type=script&lang=js"
import style0 from "./FormAlunoBasic.vue?vue&type=style&index=0&id=17623592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17623592",
  null
  
)

export default component.exports